import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import { WindowProxy } from '@sm360/widget-commons-core-services';
import { PurchaseMethods, Quote } from '@sm360/widget-commons-vehicle';
import protectionsReducer from 'protections/reducers/protectionsReducer.js';

/* eslint no-underscore-dangle: 0 */

export default function configureStore() {
    const rootReducer = combineReducers({
        protections: protectionsReducer,
        purchaseMethods: PurchaseMethods.PurchaseMethodsReducer,
        quote: Quote.QuoteReducer,
    });

    const composeEnhancers = (WindowProxy.get() && WindowProxy.get().__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
    const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));

    return store;
}



// WEBPACK FOOTER //
// ./src/providers/redux.js